<script setup lang="ts">
import { computed, ref } from "vue";

import BaseModal, { type BaseModalProps } from "@/components/BaseModal.vue";
import BaseSpinner from "@/components/BaseSpinner.vue";

export type BaseIframeModalProps = BaseModalProps & {
  src: string;
};

const { src, ...baseModalProps } = defineProps<BaseIframeModalProps>();

const state = ref<"loading" | "loaded">();
const isLoading = computed(() => state.value === undefined || state.value === "loading");
</script>

<template>
  <BaseModal v-bind="baseModalProps">
    <div v-if="isLoading" class="position-absolute w-100 text-center p-5 z-3">
      <BaseSpinner />
    </div>
    <iframe
      :src
      class="position-absolute w-100 h-100 m-n3"
      @loadstart="state = 'loading'"
      @load="state = 'loaded'"
    ></iframe>
  </BaseModal>
</template>
